import { setupPageDataEvent } from "@src/client/analytics/dataLayerEvents/setupPageDataEvent";
import { setupAudienceSegmentsEvent } from "./audienceSegmentsEvents";

export const setupPageLoadDataLayerEvents = () => {
  setupPageDataEvent();
  setupAudienceSegmentsEvent();
};
